import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getUnifiedLinksRpcContract = rpcContract({
  name: "getUnifiedLinks",
  paramsSchema: v.object({
    influencerId: v.optional(
      v.pipe(
        v.string("influencerId must be a string"),
        v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
      ),
    ),
  }),
  resultSchema: v.object({
    links: v.array(
      v.object({
        id: v.string(),
        created: v.string(), // ISO date string
        last_updated: v.string(), // ISO date string
        title: v.string(),
        url: v.string(),
        teaser: v.nullable(v.string()),
        priority: v.number(),
        exclusive: v.boolean(),
        waiting_list: v.boolean(),
        influencer_id: v.string(),
        file_id: v.nullable(v.string()),
        thumbnail: v.nullable(v.string()),

        // Discount fields
        has_discount: v.boolean(),
        code: v.nullable(v.string()),
        brand_id: v.nullable(v.string()),
        published_at: v.nullable(v.string()), // ISO date string
        start_date: v.nullable(v.string()), // ISO date string
        end_date: v.nullable(v.string()), // ISO date string
        status: v.optional(v.union([v.literal("live"), v.literal("upcoming"), v.literal("expired")])),

        // Relations
        promotion_brand: v.nullable(
          v.object({
            id: v.string(),
            name: v.string(),
            thumbnail: v.nullable(v.string()),
          }),
        ),
        promotion_file: v.nullable(
          v.object({
            id: v.string(),
            path: v.string(),
            thumbnail_path: v.nullable(v.string()),
            mime_type: v.string(),
          }),
        ),
      }),
    ),
    counts: v.object({
      total: v.number(), // Total links
      live: v.number(), // Live discount links
      upcoming: v.number(), // Upcoming discount links
      expired: v.number(), // Expired discount links
    }),
  }),
});

export type GetUnifiedLinksParams = v.InferOutput<(typeof getUnifiedLinksRpcContract)["paramsSchema"]>;
export type GetUnifiedLinksResult = v.InferOutput<(typeof getUnifiedLinksRpcContract)["resultSchema"]>;
export type UnifiedLink = v.InferOutput<(typeof getUnifiedLinksRpcContract)["resultSchema"]>["links"][0];
export type UnifiedLinkWithStatus = v.InferOutput<(typeof getUnifiedLinksRpcContract)["resultSchema"]>["links"][0];
